import ReactDOM from "react-dom/client";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { ApolloProvider } from "@apollo/client";
import App from "./App";
import keycloak from "./keycloak";
import apolloClient from "./apolloClient";
import { setAuthTokens } from "./auth/authTokens";
import "./styles/global.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    onTokens={({ token, refreshToken }) => {
      setAuthTokens({ token, refreshToken });
    }}
  >
    <ApolloProvider client={apolloClient}>
      <App />
    </ApolloProvider>
  </ReactKeycloakProvider>
);
